import VuexPersist from 'vuex-persist'
import Vue from 'vue'
import Vuex from 'vuex'
import localforage from 'localforage'

// // Stores imports
import app from '@/stores/app'
import annoncesCommerciaux from './stores/annoncesCommerciaux'
import notifications from '@/stores/notifications'
import posts from '@/stores/posts'
import postsVo from '@/stores/postsVo'
import contacts from '@/stores/contacts'
import portals from '@/stores/portals'
import reportByPortal from '@/stores/reportByPortal'
import users from '@/stores/users'
import exports from '@/stores/exports'
import donnees from '@/stores/donnees'
import diffuseurs from '@/stores/diffuseurs'
import productLine from '@/stores/productLine'
import globalDiffusionReport from '@/stores/globalDiffusionReport'
import globalIntegrationReport from '@/stores/globalIntegrationReport'
import globalreport from '@/stores/globalreport'
import KPI from '@/stores/KPI'
import portalsSecondaryList from '@/stores/portalsSecondaryList'
import portalsSocialManagment from '@/stores/portalsSocialManagment'
import broadcast from '@/stores/broadcast'
import contactsList from '@/stores/contactsList'
import contactsListPortals from '@/stores/contactsListPortals'
import contactsListPosts from '@/stores/contactsListPosts'
import contactsListVisites from '@/stores/contactsListVisites'
import contactsListRapprochementPortals from '@/stores/contactsListRapprochementPortals'
import detailContactsPerPortal from '@/stores/detailContactsPerPortal'
import detailContactsPerPost from '@/stores/detailContactsPerPost'
import dialogsPostsListImmo from '@/stores/dialogsPostsListImmo'
import socialNetworkPosts from '@/stores/socialNetworkPosts'
import storeClap from '@/stores/storeClap'
import calendarSocialPosts from '@/stores/calendarSocialPosts'
import etablishmentSheet from '@/stores/etablishmentSheet'
import lamotte from '@/stores/lamotte'
import postEditImmo from '@/stores/postEditImmo'
import postEditVo from '@/stores/postEditVo'
import socialPostsCreationPostEditorial from '@/stores/socialPostsCreationPostEditorial'
import socialPostsEditoModeles from '@/stores/socialPostsEditoModeles'
import socialPostsTableAnnonces from '@/stores/socialPostsTableAnnonces'
import socialPostsTableBiensVendus from '@/stores/socialPostsTableBiensVendus'
import socialPostsTableEditoriaux from '@/stores/socialPostsTableEditoriaux'
import socialReviewsList from '@/stores/socialReviewsList'
import tutoralsVideos from '@/stores/tutoralsVideos'
import suggestedReviews from '@/stores/suggestedReviews'
import postsListImmo from '@/stores/postsListImmo'
import statisticsMeta from '@/stores/statisticsMeta'
import statisticsDBKS from '@/stores/statisticsDBKS'
import statisticsGoogle from '@/stores/statisticsGoogle'
import statisticsLinkedin from '@/stores/statisticsLinkedin'
import promptLibraries from '@/stores/promptLibraries'
import bienVendu from '@/stores/bienVendu'
import caption from '@/stores/caption'
import definitionDonneesListe from '@/stores/definitionDonneesListe'
import postManager from '@/stores/postManager'
Vue.use(Vuex)

const vuexPersistApp = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-app',
  storage: window.localStorage,
  modules: ['app']
})

const vuexPersistAnnoncesCommerciaux = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-annonces-commerciaux',
  storage: window.localStorage,
  modules: ['annonces-commerciaux']
})
const vuexPersistBienVendu = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-bienVendu',
  storage: window.localStorage,
  modules: ['bienVendu']
})
const vuexPersistBroadcast = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-broadcast',
  storage: localforage,
  modules: ['broadcast']
})
const vuexPersistCalendarSocialPosts = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-calendarSocialPosts',
  storage: window.localStorage,
  modules: ['calendarSocialPosts']
})
const vuexPersistCaption = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-caption',
  storage: window.localStorage,
  modules: ['caption']
})
const vuexPersistContacts = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-contacts',
  storage: window.localStorage,
  modules: ['contacts']
})
const vuexPersistContactsList = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-contactsList',
  storage: window.localStorage,
  modules: ['contactsList']
})
const vuexPersistContactsListPosts = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-contactsListPosts',
  storage: window.localStorage,
  modules: ['contactsListPosts']
})
const vuexPersistContactsListVisites = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-contactsListVisites',
  storage: window.localStorage,
  modules: ['contactsListVisites']
})
const vuexPersistContactsListPortals = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-contactsListPortals',
  storage: window.localStorage,
  modules: ['contactsListPortals']
})
const vuexPersistContactsListRapprochementPortals = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-contactsListRapprochementPortals',
  storage: window.localStorage,
  modules: ['contactsListRapprochementPortals']
})

const vuexPersistDetailContactsPerPortal = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-detailContactsPerPortal',
  storage: window.localStorage,
  modules: ['detailContactsPerPortal']
})
const vuexPersistDetailContactsPerPost = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-detailContactsPerPost',
  storage: window.localStorage,
  modules: ['detailContactsPerPost']
})
const vuexPersistDefinitionDonneesListe = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-definitionDonneesListe',
  storage: window.localStorage,
  modules: ['definitionDonneesListe']
})
const vuexPersistDialogsPostsListImmo = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-dialogsPostsListImmo',
  storage: window.localStorage,
  modules: ['dialogsPostsListImmo']
})
const vuexPersistDiffuseurs = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-diffuseurs',
  storage: window.localStorage,
  modules: ['diffuseurs']
})
const vuexPersistDonnees = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-donnees',
  storage: window.localStorage,
  modules: ['donnees']
})
const vuexPersistEtablishmentSheet = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-etablishment-sheet',
  storage: window.localStorage,
  modules: ['etablishmentSheet']
})
const vuexPersistExports = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-exports',
  storage: window.localStorage,
  modules: ['exports']
})
const vuexPersistGlobalDiffusionReport = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-globalDiffusionReport',
  storage: localforage,
  modules: ['globalDiffusionReport']
})

const vuexPersistGlobalIntegrationReport = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-globalIntegrationReport',
  storage: window.localStorage,
  modules: ['globalIntegrationReport']
})
const vuexPersistGlobalreport = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-globalreport',
  storage: window.localStorage,
  modules: ['globalreport']
})
const vuexPersistKPI = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-KPI',
  storage: window.localStorage,
  modules: ['KPI']
})
const vuexPersistLamotte = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-lamotte',
  storage: window.localStorage,
  modules: ['lamotte']
})
const vuexPersistNotifications = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-notifications',
  storage: window.localStorage,
  modules: ['notifications']
})
const vuexPersistPortals = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-portals',
  storage: window.localStorage,
  modules: ['portals']
})
const vuexPersistPortalsSocialManagment = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-portalsSocialManagment',
  storage: window.localStorage,
  modules: ['portalsSocialManagment']
})
const vuexPersistPortalsSecondaryList = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-portalsSecondaryList',
  storage: window.localStorage,
  modules: ['portalsSecondaryList']
})
const vuexPersistPosts = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-posts',
  storage: window.localStorage,
  modules: ['posts']
})
const vuexPersistPostEditVo = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-postEditVo',
  storage: window.localStorage,
  modules: ['postEditVo']
})
const vuexPersistPostsListImmo = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-posts-list-immo',
  storage: localforage,
  modules: ['postsListImmo']
})
const vuexPersistPostManager = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-post-manager',
  storage: window.localStorage,
  modules: ['postManager']
})
const vuexPersistPostsVo = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-postsVo',
  storage: window.localStorage,
  modules: ['postsVo']
})
const vuexPersistProductLine = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-productLine',
  storage: window.localStorage,
  modules: ['productLine']
})
const vuexPersistPromptLibraries = new VuexPersist(
  {
    key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-promptLibraries',
    storage: window.localStorage,
    modules: ['promptLibraries']
  }
)
const vuexPersistReportByPortal = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-report-by-portal',
  storage: window.localStorage,
  modules: ['reportByPortal']
})
const vuexPersistSocialNetworkPosts = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-socialNetworkPosts',
  storage: window.localStorage,
  modules: ['socialNetworkPosts']
})
const vuexPersistSocialPostsTableAnnonces = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-socialPostsTableAnnonces',
  storage: window.localStorage,
  modules: ['socialPostsTableAnnonces']
})
const vuexPersistSocialPostsTableBiensVendus = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-socialPostsTableBiensVendus',
  storage: window.localStorage,
  modules: ['socialPostsTableBiensVendus']
})
const vuexPersistSocialPostsCreationPostEditorial = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-socialPostsCreationPostEditorial',
  storage: localforage,
  modules: ['socialPostsCreationPostEditorial']
})
const vuexPersistSocialPostsEditoModeles = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-socialPostsEditoModeles',
  storage: localforage,
  modules: ['socialPostsEditoModeles']
})
const vuexPersistSocialPostsTableEditoriaux = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-socialPostsTableEditoriaux',
  storage: window.localStorage,
  modules: ['socialPostsTableEditoriaux']
})
const vuexPersistSocialReviewsList = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-socialReviewsList',
  storage: window.localStorage,
  modules: ['socialReviewsList']
})
const vuexPersistStoreStatisticsMeta = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-statisticsMeta',
  storage: window.localStorage,
  modules: ['statisticsMeta']
}
)
const vuexPersistStoreStatisticsGoogle = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-statisticsGoogle',
  storage: window.localStorage,
  modules: ['statisticsGoogle']
}
)
const vuexPersistStoreStatisticsLinkedin = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-statisticsLinkedin',
  storage: window.localStorage,
  modules: ['statisticsLinkedin']
}
)
const vuexPersistStoreStatisticsDBKS = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-statisticsMeta-dbks',
  storage: window.localStorage,
  modules: ['statisticsDBKS']
}
)
const vuexPersistStoreClap = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-storeClap',
  storage: window.localStorage,
  modules: ['storeClap']
})
const vuexPersistStoreSuggestedReviews = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-suggestedReviews',
  storage: window.localStorage,
  modules: ['suggestedReviews']
})
const vuexPersistTutoralsVideos = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-tutoralsVideos',
  storage: window.localStorage,
  modules: ['tutoralsVideos']
})
const vuexPersistUsers = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-users',
  storage: window.localStorage,
  modules: ['users']
})
const vuexPersistPostEditImmo = new VuexPersist({
  key: processEnvConfig.VUE_APP_ENV + '-espace-client-ubiflow-post-edit-immo',
  storage: window.localStorage,
  modules: ['postEditImmo']
})

export default new Vuex.Store({
  modules: {
    app,
    annoncesCommerciaux,
    bienVendu,
    broadcast,
    calendarSocialPosts,
    caption,
    contacts,
    contactsList,
    contactsListPosts,
    contactsListVisites,
    contactsListPortals,
    contactsListRapprochementPortals,
    detailContactsPerPortal,
    detailContactsPerPost,
    definitionDonneesListe,
    dialogsPostsListImmo,
    diffuseurs,
    donnees,
    etablishmentSheet,
    exports,
    globalreport,
    globalDiffusionReport,
    globalIntegrationReport,
    KPI,
    lamotte,
    notifications,
    portals,
    portalsSocialManagment,
    portalsSecondaryList,
    posts,
    postEditImmo,
    postEditVo,
    postsListImmo,
    postManager,
    postsVo,
    productLine,
    promptLibraries,
    reportByPortal,
    socialNetworkPosts,
    socialPostsCreationPostEditorial,
    socialPostsEditoModeles,
    socialPostsTableAnnonces,
    socialPostsTableBiensVendus,
    socialPostsTableEditoriaux,
    socialReviewsList,
    storeClap,
    suggestedReviews,
    statisticsMeta,
    statisticsLinkedin,
    statisticsGoogle,
    statisticsDBKS,
    tutoralsVideos,
    users
  },
  plugins: [
    vuexPersistApp.plugin,
    vuexPersistAnnoncesCommerciaux.plugin,
    vuexPersistBienVendu.plugin,
    vuexPersistBroadcast.plugin,
    vuexPersistCalendarSocialPosts.plugin,
    vuexPersistCaption.plugin,
    vuexPersistContacts.plugin,
    vuexPersistContactsList.plugin,
    vuexPersistContactsListPosts.plugin,
    vuexPersistContactsListVisites.plugin,
    vuexPersistContactsListPortals.plugin,
    vuexPersistContactsListRapprochementPortals.plugin,
    vuexPersistDetailContactsPerPortal.plugin,
    vuexPersistDetailContactsPerPost.plugin,
    vuexPersistDefinitionDonneesListe.plugin,
    vuexPersistDialogsPostsListImmo.plugin,
    vuexPersistDiffuseurs.plugin,
    vuexPersistDonnees.plugin,
    vuexPersistEtablishmentSheet.plugin,
    vuexPersistExports.plugin,
    vuexPersistGlobalDiffusionReport.plugin,
    vuexPersistGlobalIntegrationReport.plugin,
    vuexPersistGlobalreport.plugin,
    vuexPersistKPI.plugin,
    vuexPersistLamotte.plugin,
    vuexPersistNotifications.plugin,
    vuexPersistPortals.plugin,
    vuexPersistPortalsSocialManagment.plugin,
    vuexPersistPortalsSecondaryList.plugin,
    vuexPersistPosts.plugin,
    vuexPersistPostEditImmo.plugin,
    vuexPersistPostEditVo.plugin,
    vuexPersistPostManager.plugin,
    vuexPersistPostsListImmo.plugin,
    vuexPersistPostsVo.plugin,
    vuexPersistProductLine.plugin,
    vuexPersistPromptLibraries.plugin,
    vuexPersistReportByPortal.plugin,
    vuexPersistSocialNetworkPosts.plugin,
    vuexPersistSocialPostsCreationPostEditorial.plugin,
    vuexPersistSocialPostsEditoModeles.plugin,
    vuexPersistSocialPostsTableAnnonces.plugin,
    vuexPersistSocialPostsTableBiensVendus.plugin,
    vuexPersistSocialPostsTableEditoriaux.plugin,
    vuexPersistSocialReviewsList.plugin,
    vuexPersistStoreStatisticsGoogle.plugin,
    vuexPersistStoreStatisticsMeta.plugin,
    vuexPersistStoreStatisticsLinkedin.plugin,
    vuexPersistStoreStatisticsDBKS.plugin,
    vuexPersistStoreClap.plugin,
    vuexPersistStoreSuggestedReviews.plugin,
    vuexPersistTutoralsVideos.plugin,
    vuexPersistUsers.plugin
  ]
})
